// import TabML from '@/components/tab_ml/TabML';
import BaseInfomationStyled from '../../containers/base_infomation/BaseInfomation';
import MemberDetail from '../../containers/member_detail/MemberDetail';
import ConsumptionRecord from '../../containers/consumption_record/ConsumptionRecord';
import IntegralHistory from '../../containers/integral_history/IntegralHistory';
import GradeChange from '../../containers/grade_change/GradeChange';
// import MoldingChange from '../../containers/molding_change/MoldingChange';
import CouponRecord from '../../containers/coupon_record/CouponRecord';
import { useLocation, history, useIntl } from 'umi';
import { useDispatch } from 'dva';
import BindRecord from '../../containers/bind_record/BindRecord';
import React from 'react';
import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
// import { makeStyles } from '@material-ui/styles';
// import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DetailTabStyled from './DetailTabStyled';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      {...other}
    >
      {value === index && (
        <Box style={{ overflowX: 'hidden' }} className="content-wrapper">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// const useStyles = makeStyles(() => ({
//   root: {
//     flexGrow: 1,
//   },
// }));

const DetailTab = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  // const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();

  const { query, pathname } = location;
  //保持状态
  const { tab, id, memberCode, mobile } = query;
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    dispatch({
      type: 'ml/getMemberDetail',
      payload: {
        values: {
          memberID: id,
          memberCode,
          mobile,
        },
      },
    });
    history.replace({ pathname, query: { ...query, tab: newValue } });
    // setValue(newValue);
  };
  const { params = {}, onChange, datas = {} } = props || {};

  const rightTabArr = [
    // {
    //   key: '1-1',
    //   name: '概览',
    //   child: <ModalContent />,
    // },
    {
      key: '1',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl01' }),
      child: <MemberDetail params={params} />,
    },
    {
      key: '5',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl02' }),
      child: <BindRecord params={params} />,
    },
    {
      key: '2',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl03' }),
      child: <ConsumptionRecord params={params} />,
    },
    {
      key: '3',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl04' }),
      child: <IntegralHistory params={params} />,
    },
    // {
    //   key: '7',
    //   name: '型动值历史',
    //   child: <MoldingChange params={params} />,
    // },
    {
      key: '4',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl05' }),
      child: <GradeChange params={params} />,
    },
    {
      key: '6',
      name: formatMessage({ id: 'cm.member.detail.n02.lbl06' }),
      child: <CouponRecord params={params} />,
    },
  ];

  return (
    <DetailTabStyled theme={theme}>
      {onChange ? (
        // <div className={`${classes.root} second-wrapper`}>
        <div className="second-wrapper">
          {/* <AppBar position="static" style={{ border: 0 }}> */}
          <Tabs value={Number(tab)} onChange={handleChange}>
            {rightTabArr.map((item, index) => (
              <Tab key={item.key} label={item.name} {...a11yProps(index)} />
            ))}
          </Tabs>
          {/* </AppBar> */}
          {rightTabArr.map((i, index) => (
            <TabPanel value={Number(tab)} index={index} key={i.key}>
              {i.child}
            </TabPanel>
          ))}
        </div>
      ) : (
        <BaseInfomationStyled params={params} datas={datas} />
      )}
    </DetailTabStyled>
  );
};
export default DetailTab;
